<template>
    <div id="seguranca-page">
        <Menu-component />
        <div class="container">
            <!-- SECTION 01 -->
            <section class="section-01">
                <div class="background">
                    <div class="content-wrapper">
                        <div class="title">
                            <h2>O Índice de Segurança Hídrica (ISH)</h2>
                            <p>O Índice de Segurança Hídrica foi concebido para retratar, com simplicidade e clareza, as diferentes dimensões da segurança hídrica, incorporando o conceito de risco aos usos da água.</p>
                            <h4>Dimensões do ISH</h4>
                        </div>
                        <div class="box-wrapper">
                            <div class="box-collape">
                                <div @click="toggleCollapse(true)">
                                    <VueFaqAccordion :items="itensCollapse" ref="accordion"/>
                                </div>

                            </div>
                            <div class="box-info">
                                <div id="info-info">
                                    <span class="text-top">Dimensão Humana</span>
                                    <span class="text-right">Dimensão Ecossistêmica</span>
                                    <span class="text-bottom" :class="{'active': collapseActive}">Dimensão de Resiliência </span>
                                    <span class="text-left">Dimensão Econômica</span>
                                </div>
                            </div>
                        </div>
                        <div class="navegacao">
                            <div class="arrow-down" @click="next">
                                <img src="@/assets/arrow-down.svg" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="background section-02">
                    <div class="content-wrapper">
                        <div class="wrap">
                            <div class="info-02">
                                 <h4>Mapa do ISH</h4>
                                <img src="@/assets/info-06.png" alt="">
                            </div>
                            <div class="box-info-ish">
                                <p>A Segurança Hídrica é fundamental para um desenvolvimento sustentável e ela existe quando há água disponível em quantidade e qualidade suficientes para atender às necessidades humanas e econômicas e à conservação dos ecossistemas aquáticos, com um nível aceitável de risco relacionado a secas e cheias.</p>
                                <p>O Brasil é um país caracterizado por grande diversidade climática, de ecossistemas e de uso e ocupação da terra, o que resulta em desafios para o estabelecimento de indicadores de segurança hídrica. O PNSH inova ao apresentar um Índice de Segurança Hídrica (ISH) que considera as quatro dimensões do conceito de segurança hídrica (humana, econômica, ecossistêmica e de resiliência), agregadas para compor um índice global para o Brasil, representativo da diversidade do território nacional. </p>
                                <p>O ISH foi calculado para os anos de 2017 e 2035. Ambos consideram apenas a infraestrutura hídrica existente e se diferenciam pela incorporação das demandas setoriais de uso da água no cenário futuro.  Predominam no cenário de 2035 áreas com menor segurança hídrica na região Nordeste, enquanto as áreas com maior segurança hídrica possuem uma combinação entre uma disponibilidade hídrica natural mais elevada e uma pequena pressão de demandas.</p>
                            </div>
                        </div>
                        <router-link tag="button" class="btn-green" to="construcao">A construção</router-link>
                        <div class="navegacao">
                            <div class="arrow-down" @click="prev">
                                <img src="@/assets/arrow-up.svg" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>


</template>


<script>
import Menu from '@/components/Menu'
import VueFaqAccordion from 'vue-faq-accordion'


export default {
  components: {
    VueFaqAccordion,
    'Menu-component': Menu
  },

  data () {
    return {
      itensCollapse: [
        {
          title: 'Dimensão Humana',
          value: 'Avalia a garantia da oferta de água para o abastecimento de todas as cidades do País. Em 2017, foram identificadas 60,9 milhões de pessoas que vivem em cidades com menor garantia de abastecimento de água. No horizonte de 2035, a população total em risco sobe para 73,7 milhões de pessoas. '
        },
        {
          title: 'Dimensão Econômica',
          value: 'Afere a garantia de água para os setores agropecuário e industrial. O risco total da produção econômica desses setores no País, num cenário de crise hídrica severa, era de R$ 228,4 bilhões em 2017, correspondente a cerca de 13% do PIB dos mesmos setores naquele ano. Para 2035, projeta-se um aumento do risco total para R$ 518,2 bilhões. '
        },
        {
          title: 'Dimensão Ecossistêmica',
          value: 'Sinaliza a vulnerabilidade de mananciais para abastecimento humano e usos múltiplos, derivada da capacidade de manutenção de um estoque de água para usos naturais e da exposição desse estoque natural a riscos ambientais advindos de fontes poluidoras de esgotos domésticos e rejeitos de mineração. Cerca de 2% da área do País está com grau de segurança mínimo, devido, principalmente, a altas concentrações de poluentes orgânicos nos cursos d’água.'
        },
        {
          title: 'Dimensão de Resiliência',
          value: 'Expressa o potencial dos estoques de água naturais (superficiais e subterrâneos) e artificiais do Brasil e a espacialização da capacidade de renovação dos mesmos pela precipitação. O resultado dessa dimensão indica a região semiárida como a mais vulnerável.'
        }
      ],
      eventoScroll: null,
      delta: null,
      ticking: false,
      scrollSensitivitySetting: 30,
      currentSlideNumber: 0,
      totalSlideNumber: null,
      slideDurationSetting: 600,
      collapseActive: false
    }
  },

  destroyed () {
      window.removeEventListener('wheel', this.onMouseWheel);
   },


  mounted () {
    this.totalSlideNumber = document.querySelectorAll('.background').length;
    this.previousItem()
    this.mousewhellevent();
  },

  methods: {

    mousewhellevent () {
      let screen = window.screen.width
      if (screen <= 1200) {
        return false
      }

       window.addEventListener('wheel', this.onMouseWheel);
    },

    onMouseWheel (evt) {
        this.eventoScroll = evt
        this.parallaxScroll(this.eventoScroll)
    },

    toggleCollapse () {
        this.collapseActive = this.$refs.accordion.activeQuestionIndex !== null
    },

    parallaxScroll (evt) {
      let isFirefox = (/Firefox/i.test(navigator.userAgent));
      let isIe = (/MSIE/i.test(navigator.userAgent)) || (/Trident.*rv\:11\./i.test(navigator.userAgent));

      if (isFirefox) {
        this.delta = evt.detail * (-120);
        console.log('aqui no firefox')
      } else if (isIe) {
        this.delta = -evt.deltaY;
      } else {
        this.delta = evt.wheelDelta;
      }

      if (this.ticking !== true) {
        if (this.delta <= -this.scrollSensitivitySetting) {
          this.ticking = true;

          if (this.currentSlideNumber !== this.totalSlideNumber - 1) {
            this.currentSlideNumber++;
            this.nextItem();
          }
          this.slideDurationTimeout(this.slideDurationSetting);
        }
        if (this.delta >= this.scrollSensitivitySetting) {
          this.ticking = true;
          if (this.currentSlideNumber !== 0) {
            this.currentSlideNumber--;
          }
          this.previousItem();
          this.slideDurationTimeout(this.slideDurationSetting);
        }
      }
    },

    nextItem () {
      var $previousSlide = document.querySelectorAll('.background')[this.currentSlideNumber - 1];
       $previousSlide.classList.remove('up-scroll')
       $previousSlide.classList.add('down-scroll');
    },

    previousItem () {
      var $currentSlide = document.querySelectorAll('.background')[this.currentSlideNumber];
      $currentSlide.classList.remove('down-scroll')
      $currentSlide.classList.add('up-scroll');
    },

    next () {
        this.currentSlideNumber++;
        this.nextItem()
    },

    prev () {
        this.currentSlideNumber--;
        this.previousItem()
    },

    slideDurationTimeout (slideDuration) {
      setTimeout(() => {
        this.ticking = false;
      }, slideDuration);
    }
  }
}
</script>


<style lang="scss" scoped>

.container {
  padding-top: 70px;
  width: 1235px;
  @include media_tablet() {
    width: 100%;
  }
}

.content-wrapper {
    width: 1235px;
    position: relative;
    @include media_tablet() {
        width: 100%;
        position: initial;
    }
}

#seguranca-page {

 position: relative;
    &::after {
        content: '';
        background-image: url(../assets/assets-esquerda.svg);
        background-repeat: no-repeat;
        background-size: contain;
        position: absolute;
        top: 0;
        left: 0px;
        height: 60vh;
        width: 10vh;
        @include media_tablet() {
          display: none;
        }
    }

    &::before {
        content: '';
        background-image: url(../assets/assets-direita.svg);
        background-repeat: no-repeat;
        background-size: contain;
        position: absolute;
        top: 189px;
        right: 0px;
        height: 995px;
        width: 21vh;
        @include media_tablet() {
          display: none;
        }
    }

  .title {
    padding-left: 209px;

    @include media_tablet() {
        padding-left: 23px;
    }

    h2 {
        color: #3994d0;
        font-size: 22px;
        margin-bottom: 56px;
        position: relative;

      @include media_tablet() {
        font-size: 20px;
      }

      &::before {
        content: '';
        position: absolute;
        left: -70px;
        width: 367px;
        height: 2px;
        bottom: -10px;
        background-color: #3994d0;
        transition: all 200ms ease-in-out;
        animation: slideInFromLeft 600ms ease-in;
        @include media_tablet() {
            width: 170px;
        }
      }
    }

    h4 {
      color: #575757;
      font-family: 'rubik_bold';
      font-size: 18px;
      margin-top: 15px;
    }

    p {
      color: #565656;
      line-height: 24px;
      margin-top: 20px;
      width: 40%;
      @include media_tablet() {
        width: 100%;
      }
    }
  }

  .box-wrapper {
    display: flex;
    background-color: #3994d0;
    margin-top: 40px;
    width: 1235px;
    @include media_tablet() {
      flex-direction: column;
      width: 100%;
        height: auto;
        margin-bottom: 35px;

    }
    .box-collape {
      padding: 15px 40px 25px 100px;
      width: 555px;
      @include media_tablet() {
        padding: 0px 15px;
        width: 100%;
      }
    }
    .box-info {
      position: relative;
      width: 60%;
      @include media_tablet() {
        width: 100%;
        height: 320px;
        margin-bottom: 0;
      }
      #info-info {
        background-image: url(../assets/info-05.png);
        background-repeat: no-repeat;
        background-position: center center;
        background-size: contain;
        height: 380px;
        width: 100%;
        position: absolute;
        top: -55px;
        z-index: 1;
        @media (max-height:  900px) and (min-width: 1200px) {
           height: 275px;
        }
        @include media_tablet() {
            height: 310px;
            top: 0px;
            background-color: #3994d0;
            background-size: 70%;
        }
      }

      .text-top {
        color: #3994d0;
        font-weight: bold;
        font-size: 14px;
        line-height: 26px;
        position: absolute;
        top: -30px;
        left: 0;
        right: 0;
        display: block;
        text-align: center;
        @include media_tablet() {
            color: #fff;
            top: 15px;
            left: 5px;
            font-size: 13px;
        }
      }

      .text-left {
          position: absolute;
          left: 0;
          top: 180px;
          font-size: 14px;
          font-weight: bold;
          width: 135px;
          text-align: center;
          @media (max-height:  900px) and (min-width: 1200px) {
            left: 15px;
            top: 140px;
          }
          @include media_tablet() {
            left: 0;
            top: 65px;
            font-size: 13px;
            width: 100px;
          }
      }

      .text-right {
        position: absolute;
        right: 0px;
        top: 180px;
        width: 135px;
        font-size: 14px;
        text-align: center;
        font-weight: bold;
        @media (max-height:  900px) and (min-width: 1200px) {
          right: 30px;
          top: 140px;
        }
        @include media_tablet() {
            right: 0px;
            bottom: 63px;
            top: initial;
            font-size: 13px;
            width: 100px;
        }
      }

      .text-bottom {
        position: absolute;
        bottom: -30px;
        left: 15px;
        right: 0;
        display: block;
        text-align: center;
        color: #3994d0;
        font-weight: bold;
        font-size: 14px;


        &.active {
            color: #fff;
        }

        @include media_tablet() {
            color: #fff;
            bottom: 18px;
            left: 15px;
            font-size: 13px;
        }
      }
    }
  }


  .navegacao {
    margin-top: 30px;
  }


.section-02 {

  .wrap {
    display: flex;
    width: 1235px;
    @include media_tablet() {
        flex-direction: column;
        width: 100%;
    }
    .info-02 {
      display: flex;
      flex-direction: column;
      width: 50%;
      @include media_tablet() {
        width: 100%;
      }

        h4 {
          color: #575757;
          font-family: 'rubik_bold';
          font-size: 18px;
          text-align: center;
        }

      @media (max-height:  900px) and (min-width: 1200px) {
        width: 40%;
        display: flex;
        justify-content: center;
      }


      img {
        object-fit: contain;
        max-width: 540px;
        margin: 0 auto;
        @media (max-height:  900px) and (min-width: 1200px) {
          height: 365px;;
        }
        @include media_tablet() {
            width: 100%;
        }
      }
    }
    .box-info-ish {
      padding: 25px 25px;
      width: 60%;
      @media (max-height:  900px) and (min-width: 1200px) {
        padding: 0px 0px;
      }
      @include media_tablet() {
        width: 100%;
      }
      p {
        color: #565656;
        font-size: 14px;
        line-height: 26px;
        margin-top: 30px;
          @media (max-height:  900px) and (min-width: 1200px) {
          line-height: 22px;
          margin-top: 40px;
          font-size: 13px;

           &:nth-child(1) {
                margin: 10px 0 0 0;
           }
          }
      }
    }
  }
}
}

button {
  cursor: pointer;
  margin: 15px 0 0 auto;
  &::after {
    content: "";
    position: absolute;
    right: 62px;
    top: 17px;
    background-repeat: no-repeat;
    background-image: url(../assets/seta-direita-branca.svg);
    width: 9px;
    height: 14px;

    @include media_tablet() {
      top: 22px;
      right: 35px;
    }
  }

  @include media_tablet() {
    margin: 15px 0 0 0;
    width: 100%;
    border-radius: 30px 30px 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.navegacao {
    position: absolute;
    bottom: 22vh;
}
</style>
